import DOMPurify from 'dompurify'

/* @ngInject */
function RequestFormController ($scope, $rootScope, $translate, $timeout, $state, $q, UserService, ModalService, BriefingService, TasksService, ToastService, MessageService, BusinessDataService, AdminService, ConditionalService) {
  const getBusinessDataListDialogController = () => $q.when(import('../../../arts/dialogs/business-data/list/business-data-list-dialog.controller'))

  const WORKFLOW = 'WORKFLOW'
  const companyBillingPackage = $rootScope?.companyWithBillingPackage?.billingPackage
  $scope.isWorkflow = companyBillingPackage?.plan?.pricingPackage?.id === 4

  $scope.flags = {
    loading: true,
    disabledButton: true,
    hasDefaultBriefing: false,
    users: {
      hasMoreOptions: false,
      disabled: false,
      top: 10,
      skip: 0
    },
    briefing: {
      hasMoreOptions: false
    }
  }

  $scope.defaultBriefing = null

  $scope.userId = null
  $scope.businessDataSelected = false
  $scope.currentSection = null

  $scope.isConsultant = $rootScope.oUser.isGroupOwner
  $scope.defaultSelectedUser = null

  const api = {
    getBusinessDataListDialogController,
    _loadForm,
    _getBriefings,
    _handleGetFormsSuccess,
    _handleGetFormsError,
    _handleSuccessGetUsers,
    _addBusinessDataFieldValueAndRules,
    _fieldsFormatter,
    _loadTaskBriefingValues,
    _addFieldRules,
    _filterBriefingFields,
    _selectBusinessData,
    _getUsers,
    _hasMoreResults,
    _loadBriefing,
    _getDefaultBriefing,
    _handleSectionFields,
    _goToSection,
    _sectionsFormatter,
    _handleFieldForEdition,
    _handleSectionWithSingleDropdown
  }
  this.getApi = () => api

  $scope.loadedForm = false
  $scope.fieldSelected = {}
  $scope.forms = []
  $scope.users = []
  let oldModalReference

  activate()

  function activate (data) {
    if ($scope.taskId) {
      return api._loadTaskBriefingValues($scope.taskId)
    }

    if ($scope.briefingId) {
      $scope.fieldSelected.briefingId = $scope.briefingId
    }

    $scope.briefingType = $scope.briefingType || WORKFLOW

    if (!$rootScope.isDesktop && data && data.briefingType) {
      $scope.briefingType = data.briefingType
    }

    api._getBriefings(true, $scope.briefingType)
    api._getUsers(true, 0)
  }

  const deregisterUpdateSelectedContextWorkflow = $rootScope.$on('update-selected-context-workflow', () => {
    $scope.businessDataSelected = true
    $timeout(() => {
      if (oldModalReference) {
        ModalService.setCurrentModal(oldModalReference)
      }
      api._loadForm($scope.formId, $scope.userId)
    }, 200)
  })

  const deregisterEditContextWorkflow = $rootScope.$on('edit-context-workflow', () => {
    $timeout(() => {
      if (oldModalReference) {
        ModalService.setCurrentModal(oldModalReference)
      }
      api._selectBusinessData($scope.formId)
    }, 200)
  })

  const deregisterBussinessDataDialogClosed = $rootScope.$on('bussiness-data-dialog-closed', () => {
    if (oldModalReference) {
      ModalService.setCurrentModal(oldModalReference)
    }
  })

  $scope.$on('$destroy', () => {
    deregisterUpdateSelectedContextWorkflow()
    deregisterEditContextWorkflow()
    deregisterBussinessDataDialogClosed()
  })

  $scope.goToNewBriefing = function () {
    $state.go('admin.workflowBriefingNew', {
      campaignId: $scope.currentCampaignId
    })
    ModalService.close()
  }

  $scope.$watchGroup(['fieldSelected.briefingId', 'fieldSelected.userId'], ([selectedFormId, userIdForRequest]) => {
    const notHasDefaultBriefing = !$scope.flags.hasDefaultBriefing
    if (notHasDefaultBriefing) {
      api._loadBriefing(selectedFormId, userIdForRequest)
    }
  })

  $scope.onChangeUsers = (event) => {
    $scope.fieldSelected.userId = event.detail?.value?.value
  }

  $scope.onSearchUsers = (event) => {
    const totalCount = event.detail?.totalCount
    const search = event.detail?.search || ''
    const isFirstLoading = !search
    $scope.flags.users.skip = 0

    api._getUsers(isFirstLoading, totalCount, search)
  }

  $scope.onInfiniteUsers = (event) => {
    const totalCount = event.detail?.totalCount

    $scope.flags.users.skip = $scope.flags.users.top + $scope.flags.users.skip

    api._getUsers(false, totalCount)
  }

  $scope.onChangeBriefing = (event) => {
    $scope.fieldSelected.briefingId = event.detail?.value?.value
  }

  $scope.onSearchBriefing = (event) => {
    const search = event.detail?.search || ''
    api._getBriefings(false, $scope.briefingType, null, search)
  }

  $scope.onContinueBriefing = () => {
    if ($scope.flags.hasDefaultBriefing) {
      $scope.flags.hasDefaultBriefing = false
      api._loadBriefing($scope.fieldSelected.briefingId, $scope.fieldSelected.userId)
    }
  }

  $scope.hideRequestForm = () => {
    const notHasDefaultBriefing = !$scope.flags.hasDefaultBriefing
    const hasTaskIdAndNotBriefing = $scope.taskId || $scope.forms.length === 0
    const hasBriefingIdAndNotRequestWithUser = $scope.fieldSelected.briefingId && !$scope.requestWithUser
    const hasBriefingIdAndRequestWithUserAndUserId = $scope.fieldSelected.briefingId && $scope.requestWithUser && $scope.fieldSelected.userId

    return notHasDefaultBriefing && (hasTaskIdAndNotBriefing || hasBriefingIdAndNotRequestWithUser || hasBriefingIdAndRequestWithUserAndUserId)
  }

  $scope.disableContinueButton = () => {
    return !$scope.fieldSelected.briefingId || ($scope.requestWithUser && !$scope.fieldSelected.userId)
  }

  $scope.getSectionTagLabel = () => {
    const sectionText = $translate.instant('section')
    return `${sectionText} ${$scope.sectionNavHistory.length + 1}`
  }

  $scope.onFieldClick = () => {
    if ($scope.currentSection.fields.length === 1) {
      const field = $scope.currentSection.fields[0]
      if (field.type === 'DROPDOWN') {
        $timeout(() => {
          api._handleSectionWithSingleDropdown()
        }, 50)
      }
    }
  }

  function _getBriefings (firstLoading, type, bringArchived, search = '') {
    BriefingService.getCompanyBriefings(
      type,
      bringArchived,
      search
    )
      .then(forms => api._handleGetFormsSuccess(forms, firstLoading))
      .catch(api._handleGetFormsError)
  }

  function _handleGetFormsSuccess (forms, firstLoading) {
    $scope.flags.loading = false
    $scope.defaultBriefing = null

    const briefings = forms.rows

    if (!briefings.length) {
      if (firstLoading) {
        api._handleGetFormsError()
      }

      return
    }

    const defaultBriefing = api._getDefaultBriefing($scope.boardId, forms)

    if (firstLoading && defaultBriefing) {
      $scope.defaultBriefing = {
        label: defaultBriefing.name,
        value: defaultBriefing.id
      }

      $scope.flags.hasDefaultBriefing = true
      $scope.fieldSelected.briefingId = defaultBriefing.id
    }

    $scope.forms = forms.rows.map(form => {
      const description = form.description ? DOMPurify.sanitize(form.description, { ALLOWED_TAGS: [] }) : ''

      return {
        label: form.name,
        value: form.id,
        description
      }
    })

    $scope.form = false
  }

  function _getUsers (firstLoading, totalCount, search = '') {
    const top = $scope.flags.users.top
    const skip = $scope.flags.users.skip
    const userFilters = {
      role: $scope.isWorkflow ? ['GUEST'] : ['USER'],
      search,
      $sort: 'name'
    }
    $scope.flags.users.disabled = false

    if ($scope.isConsultant) {
      return UserService.getOwnedUsers({ $top: top, $skip: skip, search }).then(
        response => api._handleSuccessGetUsers(firstLoading, response, totalCount)
      )
    }
    return AdminService.getUsers(top, skip, userFilters).then(
      response => api._handleSuccessGetUsers(firstLoading, response, totalCount)
    )
  }

  function _handleSuccessGetUsers (firstLoading, response, totalCount) {
    const users = response.rows || response.d.results
    const count = response.count || response.d.__count

    if (firstLoading && !users.length) {
      $scope.flags.users.disabled = true
    }

    const filteredUsers = users.filter(user => user.id !== $rootScope.oUser.id)

    if ($scope.isConsultant) {
      const currentUser = {
        id: $rootScope.oUser.id,
        email: $rootScope.oUser.email,
        name: $rootScope.oUser.name,
        role: $rootScope.oUser.role,
        locale: $rootScope.oUser.locale
      }

      filteredUsers.push(currentUser)
      $scope.defaultSelectedUser = {
        label: $rootScope.oUser.name,
        value: $rootScope.oUser.id
      }
      $scope.fieldSelected.userId = $rootScope.oUser.id
    }

    $scope.users = filteredUsers.map(user => ({
      label: user.name,
      value: user.id,
      id: user.id,
      active: false,
      role: user.role,
      tag: user.role === 'GUEST' ? $translate.instant('guest.guest') : null,
      url: UserService.getUserProfileImage(user.id, user.updatedAt)
    }))

    const responseLength = firstLoading ? users.length : totalCount

    $scope.flags.users.hasMoreOptions = api._hasMoreResults(count, responseLength)
  }

  function _handleGetFormsError (error) {
    console.log({ error })
    ModalService.close(false)
    MessageService.error({
      title: $translate.instant('oopsTitle'),
      text: $translate.instant('noActiveBriefing'),
      confirmButtonText: $translate.instant('ok'),
      press: () => {
        $rootScope.getUser().then(user => {
          if ($rootScope.isUserSysAdmin(user)) {
            $state.go('admin.workflowBriefingNew')
          }
        })
      }
    })
  }

  function _loadForm (id, userId) {
    $scope.flags.loading = true
    const archivedFields = true

    const briefingPromise = userId
      ? BriefingService.getUserBriefing(id, userId)
      : BriefingService.getCompanyBriefing(id, archivedFields)

    briefingPromise.then(briefing => {
      $scope.loadedForm = true
      $scope.form = briefing

      briefing.sections.forEach(api._handleSectionFields)

      api._goToSection(briefing.sections[0])

      $scope.flags.loading = false

      const haveBusinessData = BriefingService.filterFields(briefing, field => field.businessDataFieldId)
      if (haveBusinessData.length > 0 && !$scope.businessDataSelected && !$rootScope.isGuest()) {
        api._selectBusinessData(id, userId)
      }
    }).catch((error) => {
      $scope.flags.loading = true
      console.log({ error })
      ToastService.defaultErrorToast()
    })
  }

  function _fieldsFormatter (fields, isEdit) {
    return fields.map(field => {
      api._addBusinessDataFieldValueAndRules(field, isEdit)
      api._addFieldRules(field)

      // Convert dropdowns options title to be value and label
      if (field.fields) {
        field.fields.forEach(thisField => {
          thisField.label = thisField.title
          thisField.value = thisField.title
        })

        if (field.type === 'CHECKBOX' && !field.value) {
          field.value = []
        }
      }

      return field
    })
  }

  function _addBusinessDataFieldValueAndRules (field, isEdit) {
    // If is creating request then get data from businessDataFields
    if (field && field.businessDataField && field.businessDataField.contexts.length) {
      if (!isEdit) {
        if (field.type === 'DROPDOWN' || field.type === 'RADIO' || field.type === 'CHECKBOX') {
          const selectValue = field.fields.filter(option => option.businessDataFieldId === parseInt(field.businessDataField.contexts[0].contextValue.value))
          if (selectValue.length) {
            field.value = selectValue[0].title
          } else {
            field.value = ''
          }
        } else {
          field.value = field.businessDataField.contexts[0].contextValue.value
        }
      }

      field.readOnly = !field.businessDataField.userCanEdit || (!field.businessDataField.userCanEdit && !field.value)
    }
    return field
  }

  function _addFieldRules (field) {
    if (field.rules && field.rules.length) {
      field.maxLength = parseInt(field.rules.filter(rule => rule.type === 'MAX_LENGTH').map(rule => rule.value)[0]) || undefined
      field.greatThanEqual = parseInt(field.rules.filter(rule => rule.type === 'GREATER_THAN_EQUALS').map(rule => rule.value)[0]) || undefined
    }

    return field
  }

  function _loadTaskBriefingValues (taskId) {
    const taskPromise = TasksService.getTaskById(taskId)
    const briefingPromise = TasksService.getBriefing(taskId)

    $q.all([taskPromise, briefingPromise]).then(([task, briefing]) => {
      api._sectionsFormatter(briefing.sections, task)
      $scope.form = briefing
      api._goToSection(briefing.sections[0])
    }).then(function () {
      $timeout(function () {
        $scope.flags.loading = false
      }, 500)
    })
  }

  function _filterBriefingFields (task, fields) {
    return fields.filter(field => {
      const taskDate = (new Date(task.createdAt)).getTime()
      const fieldDate = (new Date(field.createdAt)).getTime()

      if (fieldDate >= taskDate) {
        return false
      } else if (fieldDate < taskDate && field.isArchived) {
        const fieldArchivedDate = (new Date(field.updatedAt)).getTime()

        if (fieldArchivedDate < taskDate) {
          return false
        }
      }

      return true
    })
  }

  function _selectBusinessData (id, userId) {
    $scope.formId = id
    $scope.businessDataSelected = false
    BusinessDataService.getBusinessDataService().then(data => {
      oldModalReference = ModalService.getCurrentModal()
      api.getBusinessDataListDialogController().then(({ BusinessDataListDialogController }) => {
        if (data.length === 0) {
          ModalService.showModal({
            templateId: 'businessDataListDialog.html',
            templateUrl: '/arts/dialogs/business-data/list/business-data-list-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: BusinessDataListDialogController,
            data: {
              userId,
              emptyMode: {
                type: data ? 'primary' : 'secondary'
              }
            }
          })
        } else {
          ModalService.showModal({
            templateId: 'businessDataListDialog.html',
            templateUrl: '/arts/dialogs/business-data/list/business-data-list-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: BusinessDataListDialogController,
            data: {
              userId,
              page: 'workflow',
              originModalReference: oldModalReference
            }
          }).then(() => {
            if (oldModalReference) {
              ModalService.setCurrentModal(oldModalReference)
            }
          })
        }
      })
    })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return totalCount > responseLength
  }

  function _loadBriefing (briefingId, userId) {
    const shouldLoadFormWhenReqWithUser = $scope.requestWithUser && briefingId && userId
    const shouldLoadFormWhenNotReqWithUser = !$scope.requestWithUser && briefingId

    if (userId) {
      $scope.userId = userId
    }

    if (shouldLoadFormWhenReqWithUser || shouldLoadFormWhenNotReqWithUser) {
      api._loadForm(briefingId, $scope.userId)
    }
  }

  function _getDefaultBriefing (boardId, forms) {
    return forms.rows.find(form => form.board?.id === boardId && form.board?.defaultBriefing)
  }

  function _handleSectionFields (section) {
    if (section.fields) {
      section.fields = api._fieldsFormatter(section.fields)
      section.fields = section.fields.filter(field => !field.isArchived)
    }

    if (section.fields && section.fields[section.fields.length - 1] && section.fields[section.fields.length - 1].type === 'DROPDOWN') {
      section.fields[section.fields.length - 1].lastItem = true
    }

    if (section.fields.length === 1) {
      section.fields[0].onlyField = true
    }
  }

  function _goToSection (section) {
    $scope.currentSection = section
    const conditionalField = ConditionalService.findLastFieldWithConditional(section)
    $scope.currentConditonalValue = conditionalField ? conditionalField.value : null
  }

  function _sectionsFormatter (sections, task) {
    sections.forEach(section => {
      section.fields = api._filterBriefingFields(task, section.fields)
      section.fields = api._fieldsFormatter(section.fields, true)

      section.fields.forEach(field => {
        api._handleFieldForEdition(field, section, task)
      })
    })
  }

  function _handleFieldForEdition (field, section, task) {
    if (field.fields && field.fields.length) {
      field.fields = api._filterBriefingFields(task, field.fields)
    }

    let values = (field.field_values && field.field_values.length && field.field_values)
    if (field.type === 'DROPDOWN' || field.type === 'RADIO') {
      const optionValue = field.fields.filter(option => option.field_values && option.field_values.length)
      if (optionValue.length) {
        values = optionValue[0].field_values
      }
    }

    if (field.type === 'CHECKBOX') {
      const fieldValues = field.field_values[0]
      let checkedOptions = []

      if (fieldValues) {
        checkedOptions = field.fields.filter(innerField => fieldValues.metadata.find(data => data.title === innerField.title))
      }

      values = checkedOptions
    }

    if (field && field.businessDataField && (!field.businessDataField.userCanEdit && (!values || (!values.length && typeof values !== 'object')))) {
      field.disabled = true
    }

    let value
    if (field.type === 'DROPDOWN' || field.type === 'RADIO') {
      if (values.length && values[0].metadata) {
        value = values[0].metadata.title
      }
    } else if (field.type === 'NUMBER' && values && values.length) {
      value = Number(values[0].value)
    } else if (field.type === 'DATE' && values && values.length) {
      value = moment.utc(values[0].value)
    } else if (field.type === 'ATTACHMENT') {
      value = values
    } else if (field.type === 'CHECKBOX') {
      value = values.map(data => data.title)
    } else if (values && values.length) {
      value = values[0].value
    }

    field.value = value

    if (!field.value && field.isArchived) {
      const index = section.fields.findIndex(item => item.id === field.id)
      if (index !== -1) {
        section.fields.splice(index, 1)
      }
    }

    if (field.type === 'CHECKBOX' && (!values || !values.length)) {
      return []
    }
  }

  function _handleSectionWithSingleDropdown () {
    const section = $(`.briefing-section.section-${$scope.currentSection.id}`)
    const dropdown = section.find('.input-dropdown')
    const dropdownMenu = dropdown.find('.menu')
    const container = $('section.scrolling.content')
    const dropdownHeight = 70
    let expandedHeight = 185

    if (!section.length || !dropdown.length || !container.length) {
      return
    }

    if (dropdownMenu.length) {
      const menuHeight = dropdownMenu.height()
      expandedHeight = menuHeight + dropdownHeight
    }

    if (dropdown.hasClass('active')) {
      container.css('height', `${expandedHeight}px`)
    } else {
      container.css('height', 'auto')
    }
  }
}

export { RequestFormController }
